"use strict";
var _a;
exports.__esModule = true;
exports.FleetTypeToCapabilities = exports.FleetType = void 0;
var FleetType;
(function (FleetType) {
    FleetType[FleetType["Uber"] = 1] = "Uber";
    FleetType[FleetType["Deliv"] = 2] = "Deliv";
    FleetType[FleetType["Loggi"] = 3] = "Loggi";
    FleetType[FleetType["Doordash"] = 5] = "Doordash";
    FleetType[FleetType["Ifood"] = 6] = "Ifood";
    FleetType[FleetType["Rappi"] = 7] = "Rappi";
    FleetType[FleetType["MensajerosUrbanos"] = 8] = "MensajerosUrbanos";
    FleetType[FleetType["PedidosYa"] = 9] = "PedidosYa";
    FleetType[FleetType["Glovo"] = 10] = "Glovo";
    FleetType[FleetType["Domicilios"] = 11] = "Domicilios";
    FleetType[FleetType["Postmates"] = 12] = "Postmates";
    FleetType[FleetType["FedEx"] = 13] = "FedEx";
    FleetType[FleetType["Stuart"] = 14] = "Stuart";
    FleetType[FleetType["Bringg"] = 15] = "Bringg";
    FleetType[FleetType["Deliveright"] = 16] = "Deliveright";
    FleetType[FleetType["Unmanaged"] = 17] = "Unmanaged";
    FleetType[FleetType["SelfIntegrated"] = 18] = "SelfIntegrated";
    FleetType[FleetType["Hertz"] = 19] = "Hertz";
    FleetType[FleetType["Shipt"] = 20] = "Shipt";
    FleetType[FleetType["Lyft"] = 21] = "Lyft";
    FleetType[FleetType["Deliveroo"] = 22] = "Deliveroo";
    FleetType[FleetType["ShippyPro"] = 23] = "ShippyPro";
    FleetType[FleetType["EasyPost"] = 24] = "EasyPost";
    FleetType[FleetType["Roadie"] = 25] = "Roadie";
})(FleetType = exports.FleetType || (exports.FleetType = {}));
exports.FleetTypeToCapabilities = (_a = {},
    _a[FleetType.Uber] = { create_delivery: true, get_quote: true, multiple_time_windows: true, is_green: false },
    _a[FleetType.Deliv] = { create_delivery: false, get_quote: false, is_green: false },
    _a[FleetType.Loggi] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.Doordash] = { create_delivery: true, get_quote: true, is_green: false },
    _a[FleetType.Ifood] = { create_delivery: false, get_quote: false, is_green: false },
    _a[FleetType.Rappi] = { create_delivery: false, get_quote: false, is_green: false },
    _a[FleetType.MensajerosUrbanos] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.PedidosYa] = { create_delivery: false, get_quote: false, is_green: false },
    _a[FleetType.Glovo] = { create_delivery: false, get_quote: false, is_green: false },
    _a[FleetType.Domicilios] = { create_delivery: false, get_quote: false, is_green: false },
    _a[FleetType.Postmates] = { create_delivery: true, get_quote: true, is_green: false },
    _a[FleetType.FedEx] = { create_delivery: true, get_quote: true, is_green: false },
    _a[FleetType.Stuart] = { create_delivery: true, get_quote: true, update_delivery: true, is_green: false },
    _a[FleetType.Bringg] = { create_delivery: true, get_quote: false, update_delivery: true, is_green: false },
    _a[FleetType.Deliveright] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.SelfIntegrated] = { create_delivery: true, get_quote: true, update_delivery: true, is_green: false },
    _a[FleetType.Hertz] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.Shipt] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.Lyft] = { create_delivery: true, get_quote: true, is_green: false },
    _a[FleetType.Deliveroo] = { create_delivery: true, get_quote: true, is_green: false },
    _a[FleetType.ShippyPro] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.EasyPost] = { create_delivery: true, get_quote: false, is_green: false },
    _a[FleetType.Roadie] = { create_delivery: true, get_quote: true, update_delivery: true, is_green: false },
    _a);
//# sourceMappingURL=fleet.js.map